// 基础信息
export const basicInfo = {
  title: '基础信息',
  content: [{
    name: '单位全称',
    value: '',
    flag: true
  }, {
    name: '单位简称',
    value: '',
    flag: true
  }, {
    name: '组织机构代码',
    value: '',
    flag: false
  }, {
    name: '单位级别',
    value: '',
    flag: true
  }, {
    name: '所属行政区',
    value: '',
    flag: true
  }, {
    name: '上级单位',
    value: '',
    flag: false
  }, {
    name: '详细地址',
    value: '',
    flag: true
  }, {
    name: '单位联系人姓名',
    value: '',
    flag: true
  }, {
    name: '联系人手机号',
    value: '',
    flag: true
  }]
};

// 合作信息
export const cooperInfo = {
  title: '合作信息',
  content: [{
    name: '单位类别',
    value: '',
    flag: true
  }, {
    name: '合作状态',
    value: '',
    flag: true
  }]
};

// 详细信息
export const detailInfo = {
  title: '详细信息',
  content: [{
    name: '企业人数',
    value: '',
    flag: false
  }, {
    name: '企业官网',
    value: '',
    flag: false
  }, {
    name: '',
    value: '',
    flage: false
  }, {
    name: '企业简介',
    value: '',
    flage: false
  }, {
    name: '',
    value: '',
    flage: false
  }, {
    name: '',
    value: '',
    flage: false
  }, {
    name: '单位电话',
    value: '',
    flag: false
  }, {
    name: '传真',
    value: '',
    flag: false
  }, {
    name: '邮编',
    value: '',
    flag: false
  }]
};

// 单位类型
export const orgTyleList = ['', '学校', '教育集团', '教育局', '教培机构', '技术服务商'];
// 单位账号类别
export const orgKindList = ['', '正式号', '测试号', '体验号'];
// 合作状态
export const cooperationList = ['默认', '正式合作', '洽谈中', '已终止合作'];
// 单位级别
export const orgLevelList = ['默认', '区级', '市级', '省级'];
// 单位人数规模类型
export const memScopeTypeList = ['', '小于50人', '50-99人', '100-499人', '500-999人', '1000-4999人', '5000-9999人', '10000人以上'];

// 学期服务管理 - 机构列表
export const orgTableColumnsData = [{
  title: '机构名称',
  key: 'orgName',
  align: 'center'
},
{
  title: '区域',
  key: 'areaName',
  align: 'center'
}, {
  title: '操作',
  slot: 'action',
  align: 'center'
}];
// 学期服务管理 - 学校列表
export const schoolTableColumnsData = [{
  title: '学校名称',
  key: 'orgName',
  align: 'center'
},
{
  title: '本学期学生数',
  key: 'studentCnt',
  align: 'center'
},
{
  title: '区域',
  key: 'areaName',
  align: 'center'
}, {
  title: '操作',
  slot: 'action',
  align: 'center'
}];
